import { render, staticRenderFns } from "./TissBox.vue?vue&type=template&id=0f84989b&scoped=true&"
import script from "./TissBox.vue?vue&type=script&lang=js&"
export * from "./TissBox.vue?vue&type=script&lang=js&"
import style0 from "./TissBox.vue?vue&type=style&index=0&id=0f84989b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f84989b",
  null
  
)

export default component.exports